import LoadingIcon from "@/components/_other/icons/LoadingIcon";

const Box = ({children, isLoading = false, className = ''}) => {
  return (
    <div className={`bg-box py-6 px-6 border relative ${className} `}>
      {isLoading ? <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-45"><LoadingIcon className="max-w-16 text-primary" /></div> : null}
      {children}
    </div>
  );
}

export default Box;
